import { useEffect, useState } from "react";
import { CROP_HISTORY_CONFIG, EMPTY_ROW_TEMPLATE } from "../constants";
import { v4 as uuidv4 } from "uuid";

export const useCropHistoryData = (formData, fieldForm) => {
  const [rows, setRows] = useState([]);
  const [allRowsData, setAllRowsData] = useState({});

  const addRow = () => {
    const newRow = {
      ...EMPTY_ROW_TEMPLATE,
      id: uuidv4(),
    };
    setRows((prev) => [...prev, newRow]);
  };

  const deleteRow = (id) => {
    setRows((prev) => prev.filter((row) => row.id !== id));
    setAllRowsData((prev) => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  };

  const updateRowData = (rowId, data) => {
    setAllRowsData((prev) => ({
      ...prev,
      [rowId]: data,
    }));
  };

  useEffect(() => {
    const dataToUse = fieldForm || formData;
    let cropHistoryData = extractCropHistoryData(dataToUse);

    if (cropHistoryData?.length > 0) {
      const initialRows = mapToInitialRows(cropHistoryData);
      setRows(initialRows);
      setAllRowsData(mapToInitialData(initialRows, cropHistoryData));
    } else {
      setRows([]);
      setAllRowsData({});
    }
  }, [formData, fieldForm]);

  return {
    rows,
    allRowsData,
    addRow,
    deleteRow,
    updateRowData,
  };
};

const extractCropHistoryData = (dataToUse) => {
  if (!dataToUse) return null;

  let data = null;

  if (dataToUse[CROP_HISTORY_CONFIG.FIELD_KEY]) {
    data = dataToUse[CROP_HISTORY_CONFIG.FIELD_KEY];
  } else if (Array.isArray(dataToUse)) {
    data = dataToUse;
  }

  if (data && data.length > 0) {
    const currentDate = new Date();
    return data.filter((item) => {
      if (!item.start_date || !item.end_date) return true;

      const startDate = new Date(item.start_date);
      const endDate = new Date(item.end_date);

      return !(currentDate >= startDate && currentDate <= endDate);
    });
  }

  return data;
};

const mapToInitialRows = (cropHistoryData) => {
  return cropHistoryData.map((item) => ({
    id: item.colture.id || uuidv4(),
    colture: item.colture.name || item.colture || "",
    start_date: item.start_date || null,
    end_date: item.end_date || null,
  }));
};

const mapToInitialData = (initialRows, cropHistoryData) => {
  const initialData = {};
  initialRows.forEach((row, index) => {
    initialData[row.id] = cropHistoryData[index];
  });
  return initialData;
};
